import { useMemo, useState } from "react";
import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import CtaBand from "@/components/feature/CtaBand";
import Reveal from "@/components/base/Reveal";
import JournalCard from "@/components/feature/JournalCard";
import { images } from "@/mocks/site";
import { articles } from "@/mocks/journal";

const ratioCycle: Array<"tall" | "wide" | "square"> = [
  "wide",
  "tall",
  "square",
  "tall",
  "wide",
  "square",
];

export default function JournalPage() {
  const categories = useMemo(
    () => ["All", ...Array.from(new Set(articles.map((a) => a.category)))],
    []
  );
  const [active, setActive] = useState("All");

  const list =
    active === "All" ? articles : articles.filter((a) => a.category === active);

  return (
    <SiteLayout>
      <PageHero
        eyebrow="The Content Library"
        title={
          <>
            THE CHEF'S
            <br />
            TABLE
          </>
        }
        subtitle="Recipes, cooking tips, food stories, travel discoveries and behind-the-scenes moments — written the way Eddie cooks: slow, honest and full of people."
        image={images.foodPlating}
        imageClassName="object-center"
      />

      <section className="bg-background-50">
        <div className="w-full px-5 md:px-10 lg:px-16 py-16 md:py-24">
          <div className="flex flex-wrap items-center gap-2">
            {categories.map((cat) => {
              const isActive = cat === active;
              return (
                <button
                  key={cat}
                  type="button"
                  onClick={() => setActive(cat)}
                  className={`whitespace-nowrap rounded-full px-1 py-1 font-label text-[10px] uppercase tracking-label transition-all duration-300 ${
                    isActive
                      ? "bg-foreground-950 text-background-50"
                      : "text-foreground-600 hover:text-foreground-950"
                  }`}
                >
                  <span className="block rounded-full px-4 py-2">{cat}</span>
                </button>
              );
            })}
          </div>

          <div className="mt-14 columns-1 gap-8 md:columns-2 lg:columns-3">
            {list.map((article, i) => (
              <div key={article.slug} className="mb-10 break-inside-avoid">
                <Reveal delay={(i % 3) * 90}>
                  <JournalCard
                    article={article}
                    ratio={ratioCycle[i % ratioCycle.length]}
                  />
                </Reveal>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand
        eyebrow="The Invitation"
        title={
          <>
            Have a story
            <br />
            <span className="italic text-primary-400">worth telling?</span>
          </>
        }
        text="Some of the best stories start with a recommendation. Send Eddie somewhere worth discovering."
        primary={{ label: "Submit a Locavore", to: "/submit-a-locavore" }}
        secondary={{ label: "Invite Eddie", to: "/invite-eddie" }}
      />
    </SiteLayout>
  );
}